export class PartCategoryModel {
  id: number;
  name: string;
  isActive: boolean;
  description: string;
}
